import React, { useEffect } from 'react'
import {
  Panel,
  Grid,
  GridCell,
  Flex,
  FlexItem,
  Text,
  SpacingVertical,
  SPACING_8,
  SPACING_4,
  Link,
  HelpIcon,
  Title,
  TITLE_VARIANT_M,
  SkeletonLoader,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import iconRecipientSelected from 'Img/icon-recipient-selected.svg'
import iconCredit from 'Img/Icon-credit-sms.svg'
import ReactTooltip from 'react-tooltip'
import iconBuy from 'Img/icon-buy.svg'
import { evalCondition, notifyParent } from 'mailup-react-helpers'
import { useRecoilValue } from 'recoil'
import { progressState } from '../recoil/states/state'
import { pageState } from '../recoil/states/page'

const BoxCredits = () => {
  const intl = useIntl()

  const { toBeQueued, cost } = useRecoilValue(progressState)
  const { totalCredits } = useRecoilValue(pageState)
  const showMshop = evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
  )

  useEffect(() => {
    ReactTooltip.rebuild()
  }, [])

  const handleBuyCredits = () => {
    notifyParent('redirectMainFrame', ['mshop_Redirector.aspx?t=mshopcr'])
  }

  return (
    <Panel>
      <Grid>
        <GridCell span={1} />
        <GridCell span={5}>
          <Flex padding='0'>
            <FlexItem padding='0'>
              <img src={iconRecipientSelected} />
            </FlexItem>
            <FlexItem padding='12px 0 0 18px'>
              <Flex flexDirection='column'>
                <Text variant='light'>
                  {intl.formatMessage({
                    id: 'Load.Rcs.TotalSelectedRecipients'
                  })}
                </Text>
                <SpacingVertical variant={SPACING_8} />

                {toBeQueued ? (
                  <Title variant={TITLE_VARIANT_M}>
                    {intl.formatNumber(toBeQueued)}
                  </Title>
                ) : (
                  <SkeletonLoader
                    width='200px'
                    height='18px'
                    variant='onwhite'
                  />
                )}
              </Flex>
            </FlexItem>
          </Flex>
        </GridCell>
        <GridCell span={1} />
        <GridCell span={5}>
          <Flex padding='0'>
            <FlexItem padding='0'>
              <img src={iconCredit} />
            </FlexItem>
            <FlexItem padding='6px 0 0 24px'>
              <Flex flexDirection='column'>
                <Text variant='light'>
                  {intl.formatMessage({
                    id: 'Load.Rcs.CreditsAvailable'
                  })}
                  <HelpIcon
                    text={intl.formatMessage(
                      {
                        id: 'Load.Rcs.NeededCreditsTooltip'
                      },
                      {
                        linebreak: <br />
                      }
                    )}
                  />
                </Text>
                <SpacingVertical variant={SPACING_8} />

                {cost > 0 ? (
                  <Title variant={TITLE_VARIANT_M}>
                    {intl.formatNumber(cost)}
                  </Title>
                ) : (
                  <SkeletonLoader
                    width='200px'
                    height='18px'
                    variant='onwhite'
                  />
                )}

                <SpacingVertical variant={SPACING_8} />
                {totalCredits != null ? (
                  <>
                    <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                      {intl.formatMessage(
                        {
                          id: 'Load.Rcs.AvailableCredits'
                        },
                        { x: intl.formatNumber(parseFloat(totalCredits)) }
                      )}
                    </Text>
                    <SpacingVertical variant={SPACING_4} />
                    {showMshop ? (
                      <Link variant='highlight' onClick={handleBuyCredits}>
                        <Flex gap='4px' alignItems='baseline'>
                          {intl.formatMessage({
                            id: 'Load.Rcs.BuyCredits'
                          })}
                          <img src={iconBuy} />
                        </Flex>
                      </Link>
                    ) : (
                      <Text variant='light'>
                        {intl.formatMessage({
                          id: 'Load.Rcs.BuyCreditsNoMShop'
                        })}
                      </Text>
                    )}
                  </>
                ) : (
                  <SkeletonLoader
                    width='200px'
                    height='18px'
                    variant='onwhite'
                  />
                )}
              </Flex>
            </FlexItem>
          </Flex>
        </GridCell>
      </Grid>
    </Panel>
  )
}

export default BoxCredits
